import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "feed-topbar flex flex-col w-full" }
const _hoisted_2 = { class: "feed-mobile-only flex items-center px-2" }
const _hoisted_3 = { class: "desktop-shell-layout" }
const _hoisted_4 = { class: "desktop-shell-nav feed-desktop-only" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "feed-nav-link__badge"
}
const _hoisted_7 = { class: "desktop-shell-main" }
const _hoisted_8 = {
  key: 0,
  class: "my-auto"
}
const _hoisted_9 = { class: "w-4 h-4 bg-brand-lime flex rounded-full" }
const _hoisted_10 = { class: "m-auto text-xxs text-brand-black leading-normal font-medium" }
const _hoisted_11 = { class: "flex h-full relative z-40" }
const _hoisted_12 = {
  key: 0,
  class: "animate-spin h-10 w-10 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 1,
  class: "flex px-4 py-5 m-auto text-white"
}
const _hoisted_14 = {
  key: 2,
  class: "flex w-full flex-col px-4 py-5 space-y-6"
}
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col w-full space-y-4"
}
const _hoisted_16 = { class: "flex flex-col w-full space-y-4" }
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col w-full space-y-4"
}
const _hoisted_18 = { class: "flex flex-col w-full space-y-4" }

import {
  IonButton, IonButtons,
  IonContent, IonHeader, IonLabel,
  IonPage, IonRefresher, IonRefresherContent, IonSegment, IonSegmentButton, IonTitle,
  IonToolbar, onIonViewWillEnter, useIonRouter,
} from '@ionic/vue';
import {computed, onMounted, onUnmounted, Ref, ref} from 'vue';
import {FriendUserInterface} from "@/interfaces/FriendUserInterface";
import ApiService from "@/services/api/apiService";
import FriendListItem from "@/components/FriendListItem.vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import DesktopTopbar from "@/components/DesktopTopbar.vue";
import FeedDesktopSidebar from "@/components/FeedDesktopSidebar.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'FriendsTab',
  setup(__props) {

const tab = ref('friends')
const friendTabs = [
  { label: 'Friends', value: 'friends' },
  { label: 'Requests', value: 'requests' },
]

const loading = ref(true)
const observer = ref()
const friends: Ref<FriendUserInterface[]> = ref([])
const friendRequests: Ref<FriendUserInterface[]> = ref([])

const getData = async () => {

  const [i, ii]: any = await Promise.allSettled([await getFriendRequests(), await getFriends()])
  friendRequests.value = i.value
  friends.value = ii.value
  loading.value = false
}

const getFriends = async () => {
  return await ApiService.User().getFriends()
}

const getFriendRequests = async () => {
  return await ApiService.User().getFriendRequests()
}

const pullToRefresh = async (ev: any) => {
  await getData()
  ev.target.complete()
}

const getYourWinkOn = computed(() => {
  return !friends.value.length && !friendRequests.value.length;
})

onIonViewWillEnter(async () => {
  await getData()
})

onMounted(() => {

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.FriendsChanged) {
      await getData()
    }
  })

})

const tabChanged = (event: any) => {
  tab.value = event.detail.value
}

const selectTab = (value: string) => {
  tab.value = value
}

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const ionRouter = useIonRouter()

const goBack = async () => {
  await ionRouter.back()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "friends-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(DesktopTopbar, {
                  class: "feed-desktop-only",
                  "show-search": false
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(IonButtons), { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: goBack,
                        class: "bg-brand-dark-gray rounded-md"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M6 11.9961H18",
                              stroke: "white",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }),
                            _createElementVNode("path", {
                              d: "M12 18L6 12L12 6",
                              stroke: "white",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTitle), null, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "text-2xl text-white font-medium" }, "Friends", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (pullToRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-icon": "crescent",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(friendTabs, (friendTab) => {
                return _createElementVNode("button", {
                  key: friendTab.value,
                  type: "button",
                  class: _normalizeClass(["feed-nav-link", { 'feed-nav-link--active': tab.value === friendTab.value }]),
                  onClick: ($event: any) => (selectTab(friendTab.value))
                }, [
                  _createElementVNode("span", null, _toDisplayString(friendTab.label), 1),
                  (friendTab.value === 'requests' && friendRequests.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(friendRequests.value.length), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5)
              }), 64))
            ]),
            _createElementVNode("main", _hoisted_7, [
              _createVNode(_unref(IonSegment), {
                onIonChange: _cache[1] || (_cache[1] = ($event: any) => (tabChanged($event))),
                value: tab.value,
                class: "feed-mobile-only relative z-50 backdrop-blur-2xl bg-opacity-40 w-full sticky top-0",
                "swipe-gesture": false,
                mode: "ios"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegmentButton), { value: "friends" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Friends", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "requests" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "text-lg flex space-x-2 font-medium" }, {
                        default: _withCtx(() => [
                          _cache[5] || (_cache[5] = _createElementVNode("div", null, "Requests", -1)),
                          (friendRequests.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(friendRequests.value.length), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("div", _hoisted_11, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (getYourWinkOn.value && !loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                        _createElementVNode("svg", {
                          width: "75",
                          height: "74",
                          viewBox: "0 0 75 74",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M37.5006 0C17.2891 0 0.845703 16.4434 0.845703 36.6549C0.845703 56.8664 17.2891 73.3098 37.5006 73.3098C57.7121 73.3098 74.1555 56.8664 74.1555 36.6549C74.1555 16.4434 57.7121 0 37.5006 0Z",
                            fill: "#EBFF00"
                          }),
                          _createElementVNode("path", {
                            d: "M57.344 45.3167C58.4435 46.0038 58.7864 47.4604 57.9969 48.4889C55.9488 51.1572 53.3663 53.3809 50.4055 55.0124C46.7574 57.0225 42.6561 58.0668 38.4909 58.0461C34.3257 58.0254 30.235 56.9404 26.6071 54.8941C23.6626 53.2332 21.1024 50.984 19.0809 48.2954C18.3017 47.2591 18.659 45.806 19.7653 45.1298C20.8716 44.4537 22.3061 44.8129 23.1088 45.8312C24.6966 47.8454 26.6667 49.5371 28.9137 50.8045C31.8446 52.4577 35.1494 53.3342 38.5142 53.3509C41.8791 53.3677 45.1924 52.524 48.1396 50.9001C50.3991 49.6551 52.3859 47.9831 53.9937 45.9847C54.8064 44.9745 56.2445 44.6295 57.344 45.3167Z",
                            fill: "#1A1B22"
                          }),
                          _createElementVNode("path", {
                            d: "M24.5105 40.1582C25.6758 40.2425 26.5724 41.2661 26.2606 42.392C26.0533 43.1407 25.7645 43.8666 25.3979 44.5563C24.6993 45.8709 23.7338 47.0251 22.5633 47.9449C21.3928 48.8648 20.043 49.53 18.6006 49.8981C17.8437 50.0912 17.0701 50.2003 16.2937 50.2247C15.1259 50.2615 14.3434 49.1483 14.5369 47.9961C14.7304 46.8439 15.8401 46.1029 16.9933 45.9156C17.1817 45.8849 17.3689 45.846 17.5545 45.7986C18.4262 45.5762 19.2417 45.1742 19.949 44.6184C20.6563 44.0625 21.2397 43.3651 21.6619 42.5708C21.7518 42.4016 21.834 42.2289 21.9082 42.0531C22.3629 40.9768 23.3453 40.0738 24.5105 40.1582Z",
                            fill: "#1A1B22"
                          }),
                          _createElementVNode("path", {
                            d: "M32.9536 30.0211C33.9533 29.3009 34.1629 27.8739 33.2204 27.0804C32.4583 26.4388 31.6057 25.8977 30.6849 25.4747C29.0674 24.7316 27.287 24.3744 25.4949 24.4336C23.7028 24.4927 21.9521 24.9664 20.3917 25.8144C19.5056 26.2959 18.6958 26.89 17.9827 27.5781C17.0949 28.4348 17.4025 29.8458 18.45 30.4975C19.4438 31.1157 20.7341 30.7992 21.6606 30.0839C21.9433 29.8657 22.2449 29.669 22.5627 29.4963C23.5056 28.9839 24.5635 28.6977 25.6463 28.6619C26.7292 28.6262 27.8051 28.842 28.7824 29.291C29.1166 29.4445 29.4358 29.6237 29.7373 29.8263C30.7047 30.4766 32.0077 30.7024 32.9536 30.0211Z",
                            fill: "#1A1B22"
                          }),
                          _createElementVNode("path", {
                            d: "M51.5546 32.8109C54.0696 32.8109 56.1406 30.849 56.1406 28.39C56.1406 25.9309 54.0696 23.9691 51.5546 23.9691C49.0396 23.9691 46.9686 25.9309 46.9686 28.39C46.9686 30.849 49.0396 32.8109 51.5546 32.8109Z",
                            fill: "#1A1B22",
                            stroke: "#1A1B22",
                            "stroke-width": "0.916372"
                          })
                        ]),
                        _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-4 px-2" }, [
                          _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Hey sweet stuff, looks like you need to get your wink on! "),
                          _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, [
                            _createTextVNode("A connection could be just around the corner."),
                            _createElementVNode("br"),
                            _createTextVNode("Keep winking! ")
                          ])
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!getYourWinkOn.value && !loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (friendRequests.value && friendRequests.value.length && tab.value === 'requests')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendRequests.value, (user, userIndex) => {
                                return (_openBlock(), _createBlock(FriendListItem, {
                                  key: userIndex,
                                  user: user
                                }, null, 8, ["user"]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (friends.value && friends.value.length && tab.value === 'friends')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friends.value, (user, userIndex) => {
                                return (_openBlock(), _createBlock(FriendListItem, {
                                  key: userIndex,
                                  user: user
                                }, null, 8, ["user"]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(FeedDesktopSidebar, { class: "feed-desktop-only" })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})